module.exports = __webpack_public_path__ + "img/menu-icon-8.279cc28c.png";